const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export interface Insight { kind: 'campaign' | 'event' | null; facts: [string, string][]; followUp: string | null; followWhy: string | null }

function shift(label: string, n: number): string | null {
  const [m, y] = label.trim().split(/\s+/);
  const i = MONTHS.indexOf(m ?? '');
  const yr = Number(y);
  if (i < 0 || !yr) return null;
  const t = i + n;
  return `${MONTHS[((t % 12) + 12) % 12]} ${yr + Math.floor(t / 12)}`;
}

/** Reads the planner answers saved in an order's notes and suggests when to follow up. */
export function orderInsight(notes: string | null | undefined, startMonth: string | null | undefined, duration: string | null | undefined): Insight {
  const first = (notes ?? '').split('\n')[0] ?? '';
  const kind = first.startsWith('Event promotion') ? 'event' : first.startsWith('Campaign planner') ? 'campaign' : null;
  const facts: [string, string][] = [];
  if (kind) {
    const body = first.replace(/^[^—]*—\s*/, '');
    for (const part of body.split(';')) {
      const idx = part.indexOf(':');
      if (idx > 0) { const k = part.slice(0, idx).trim(); const v = part.slice(idx + 1).trim(); if (v) facts.push([k, v]); }
    }
  }
  const months = Math.max(1, parseInt(duration ?? '1', 10) || 1);
  let followUp: string | null = null;
  let followWhy: string | null = null;
  if (startMonth) {
    if (kind === 'event' || months === 1) {
      followUp = shift(startMonth, 1);
      followWhy = kind === 'event' ? 'After the event — ask how it went and offer an ongoing campaign.' : 'After their single issue — offer a longer run.';
    } else {
      followUp = shift(startMonth, months - 2);
      followWhy = 'A month before the campaign ends — offer a renewal.';
    }
  }
  return { kind, facts, followUp, followWhy };
}
